const postAddDocumentCompanies = {
  toastr: 'Document added',
  toastr: 'The document has been successfully added.'
};

export default postAddDocumentCompanies;
